import { useEffect, useMemo } from 'react';
import { useQuery, useQueryClient } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL, ITransactorInfoDto } from '@/dtos';
import { Transactor } from '@/modules/transaction/transaction.types';

export const GET_TRANSACTOR_BY_ID = 'getTransactorById';

export const useGetTransactor = (transactorId?: string) => {
  const { data, isLoading, isSuccess, isFetching, refetch } = useQuery(
    [GET_TRANSACTOR_BY_ID, transactorId],
    () => api.get(API_URL.TRANSACTORS_BY_TRANSACTOR_ID(transactorId || ''))
  );
  const queryClient = useQueryClient();
  useEffect(() => {
    if (transactorId) {
      refetch();
    } else {
      queryClient.invalidateQueries({
        queryKey: [GET_TRANSACTOR_BY_ID],
      });
    }
  }, [transactorId, refetch, queryClient]);

  const formatData = (transactor?: ITransactorInfoDto) => ({
    providerName: transactor?.name || '',
    providerAddress1: transactor?.address?.line1 || '',
    providerAddress2: transactor?.address?.line2 || '',
    providerCity: transactor?.address?.city || '',
    providerState: transactor?.address?.state?.name || '',
    providerZipCode: transactor?.address?.zipcode || '',
  });

  const formattedData = useMemo(() => formatData(data?.data), [data]);
  return {
    formattedData: formattedData as Transactor,
    data: data?.data,
    isLoading,
    isFetching,
    isSuccess,
    refetch,
  };
};
